import { Route, Routes as RoutesWrapper } from "react-router-dom";
import AuthRoutes from "./__authedRoutes";
import PublicRoutes from "./__publicRoutes";
import Layout from "../layouts";
import CombinedRoutes from "./CombinedRoutes.jsx";
import { BrokerRegistration } from "@/pages/Exporter.jsx";

const Routes = () =>
    <CombinedRoutes>
        <RoutesWrapper>
            <Route path="/*" element={<Layout><AuthRoutes /></Layout>} />
            <Route path="/auth/*" element={<PublicRoutes />} />
            <Route path="/guest/broker-registration" element={<BrokerRegistration />} />
        </RoutesWrapper>
    </CombinedRoutes>

export default Routes;